<template>
  <div v-show="enabled && set" class="Cart__Timer">
    <div class="Cart__TimerWrap" :class="iconClass">
      <Icon ref="clock" icon="clock" />
      <p class="t5">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script setup>
import Icon from '../Global/Icon.vue';

import { computed, watch, ref, onMounted } from 'vue';
import { pubSub } from '@utils/PubSub';
import { useCartStore } from './Composables/Store';

const store = useCartStore();

const clock = ref(null);
const timer = ref(false);

const set = ref(false);
const enabled = ref(false);

const startTime = ref(false);
const endTime = ref(false);

const timeToNudge = ref(false);
const nudgeShown = ref(false);

const current = ref(0);
const completed = ref(0);

const countdown = () => {
  if (!set.value || !enabled.value) return;
  timer.value = setInterval(() => {
    current.value = new Date();

    calculatePercentage();
    const surpassedNudgeTime = current.value >= timeToNudge.value;

    if (surpassedNudgeTime && !nudgeShown.value) {
      triggerNudge();
    }

    if (current.value < endTime.value) {
      calculateMinutesRemaining(endTime.value, 'timeToCountDown');
      calculateMinutesRemaining(timeToNudge.value, 'timeToNudge');
    } else {
      clearInterval(timer.value);
    }
  }, 1000);
};

const triggerNudge = () => {
  nudgeShown.value = true;
  pubSub.publish('cart:urgency:nudge');
};

const calculatePercentage = () => {
  const now = current.value.getTime();
  const total = endTime.value - startTime.value;
  const progress = now - startTime.value;
  const percentage = (progress / total) * 100;
  completed.value = percentage;
};

const calculateMinutesRemaining = (time, label) => {
  const start = current.value;
  const end = time;

  const difference = end.getTime() - start.getTime();
  const diffInMinutes = Math.round(difference / 60000);

  sessionStorage.setItem(label, diffInMinutes);
};

const updateClock = () => {
  const element = clock.value?.$el ?? false;
  if (!element) return;

  const progress = element.querySelector('.progress');
  if (!progress) return;

  const radius = progress.r.baseVal.value;
  const circumference = radius * 2 * Math.PI;
  const percentage = circumference - (completed.value / 100) * circumference;

  progress.style.strokeDasharray = circumference;
  progress.style.strokeDashoffset = percentage;
};

const message = computed(() => {
  const timeCompleted = completed.value >= 100;
  const terms = store.$state.terms.urgency;
  return timeCompleted ? terms.completed : terms.message;
});

const iconClass = computed(() => {
  const isComplete = completed.value >= 100;
  return isComplete ? 'Cart__TimerWrap--Complete' : '';
});

watch(set, countdown, { immediate: true });
watch(completed, updateClock);

onMounted(() => {
  set.value = JSON.parse(sessionStorage.getItem('urgencySet')) ?? false;
  enabled.value = JSON.parse(sessionStorage.getItem('urgencyEnabled')) ?? false;
  endTime.value = sessionStorage.getItem('timeToCountDown') ?? false;
  timeToNudge.value = sessionStorage.getItem('timeToNudge') ?? false;
  nudgeShown.value =
    JSON.parse(sessionStorage.getItem('urgencyModalShown')) ?? false;

  if (set.value) {
    startTime.value = new Date(sessionStorage.getItem('urgencyStart'));
  }

  if (endTime.value) {
    const minutes = parseInt(endTime.value);
    endTime.value = new Date();
    endTime.value.setMinutes(endTime.value.getMinutes() + minutes);
  }

  if (timeToNudge.value) {
    const minutes = parseInt(timeToNudge.value);
    timeToNudge.value = new Date();
    timeToNudge.value.setMinutes(timeToNudge.value.getMinutes() + minutes);
  }
});

pubSub.subscribe('cart:urgency:start', () => {
  set.value = true;
  startTime.value = set.value
    ? new Date(sessionStorage.getItem('urgencyStart'))
    : new Date();
});
</script>
